import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { hasShipRates, shipRange } from "@/lib/sellerNet";

// Datos del vendedor que usa Publicar: cobro, tarifas de envío, "Publicar otra igual" y sus solicitudes (P7).
export function useSellerPublishContext() {
  const [payout, setPayout] = useState(undefined);
  const [shipping, setShipping] = useState(undefined);
  const [recent, setRecent] = useState([]);
  const [requests, setRequests] = useState(null);

  const reloadPayout = useCallback(() => api.get("/seller/payout-info").then((r) => setPayout(r.data || null)).catch(() => setPayout(null)), []);
  const reloadShipping = useCallback(() => api.get("/seller/shipping-config").then((r) => setShipping(r.data || null)).catch(() => setShipping(null)), []);
  const reloadRequests = useCallback(() => api.get("/my-customs").then((r) => setRequests(Array.isArray(r.data) ? r.data : [])).catch(() => setRequests([])), []);

  useEffect(() => {
    reloadPayout(); reloadShipping(); reloadRequests();
    api.get("/seller/recent-publications").then((r) => setRecent(r.data || [])).catch(() => {});
  }, [reloadPayout, reloadShipping, reloadRequests]);

  const setLocalOnly = useCallback((v) => {
    setShipping((s) => (s ? { ...s, local_only: v } : s));
    api.patch("/seller/shipping-config/local-only", { local_only: v }).catch((e) => toast.error(e?.response?.data?.detail || "No se pudo guardar en tu perfil"));
  }, []);
  const hasRates = hasShipRates(shipping);
  return {
    payout, hasPayout: !!payout, reloadPayout,
    shipping, hasRates, shipRange: hasRates ? shipRange(shipping) : null, defaultShip: shipRange(shipping)[0], reloadShipping, setLocalOnly,
    recent, requests, reloadRequests,
    inReview: (requests || []).filter((r) => r.ui_status === "EN_REVISION").length,
  };
}
